export default __webpack_public_path__ + "static/media/remind.9d11ed3d.svg";